app.directive('overdueMessage', ["PATH", "overdueTasksService", "localStorageService", function (PATH, overdueTasksService, localStorageService) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: PATH.components + 'overdueMessage/overdueMessage.tpl.html',
    scope: {},
    link: function ($scope) {
      var userInfo = localStorageService.get('userInfo');
      $scope.message = null;

      if (!(userInfo.roleName === 'superAdmin' || userInfo.roleName === 'middleAdmin')) {
        getOverdueTasks();
      }

      function getOverdueTasks() {
        overdueTasksService.getOverdueTasks(userInfo.currentStore.id)
          .then(function(overdueTasks) {
            if (!overdueTasks.data.length) return null;
            // SAS: Removed it due to error message with wrong dates -->
            // $scope.message = 'You have open items that may create inaccuracies in reports that include the following dates: ';
            //
            // _.uniq(_.reduce(overdueTasks.data, function(initialState, task) {
            //   initialState.push(moment(task[1], 'YYYY-MM-DD').format('MM/DD/YY'));
            //   return initialState;
            // }, [])).sort(function(a, b) {
            //   return +moment(a) - +moment(b);
            // }).forEach(function(task, i) {
            //   if (i === 0) {
            //     $scope.message += task;
            //   } else {
            //     $scope.message += ', ' + task;
            //   }
            // });
          });
      }
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/overdueMessage/overdueMessageDirective.js